import Layout from './MainLayout';

export const MainLayout = Layout;
